import { useSelector } from "react-redux"

import { StoreType } from "../../../utils/types";

const useTimeOffBalancesReportData = () => {
    const balances = useSelector(
        (state: StoreType) => state.timeOffBalancesReport?.balances
    );
    const getReportStatus = useSelector(
        (state: StoreType) => state.timeOffBalancesReport?.getTimeOffBalancesReport.status
    );
    const getReportError = useSelector(
        (state: StoreType) => state.timeOffBalancesReport?.getTimeOffBalancesReport.errorMessage
    );
    const filters = useSelector(
        (state: StoreType) => state.timeOffBalancesReport?.filters
    );
    const getFiltersStatus = useSelector(
        (state: StoreType) => state.timeOffBalancesReport?.getFilters.status
    );
    const updateBalanceStatus = useSelector(
      (state: StoreType) => state.timeOffBalancesReport?.updateBalance.status
    );
    const updateBalanceErrorMessage = useSelector(
      (state: StoreType) => state.timeOffBalancesReport?.updateBalance.errorMessage
    );

    return {
        balances,
        getReportStatus,
        getReportError,
        filters,
        getFiltersStatus,
        updateBalanceStatus,
        updateBalanceErrorMessage
    };
};

export default useTimeOffBalancesReportData;
